import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_PENDING_SEASON,
  SET_TEAM_MYTHIC_PLUS_FILTERS,
  SET_TEAM_MYTHIC_PLUS_RUNS,
  SHOW_LOADING_SPINNER,
  TOGGLE_OPEN_DUNGEON
} from '../actions/keystoneTeamRunsActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TKeystoneTeamDetailsClientState } from '../libs/store';

const DEFAULT_STATE = {
  events: {}
};

export default function keystoneTeamRuns(
  state: Partial<TKeystoneTeamDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TKeystoneTeamDetailsClientState> {
  switch (action.type) {
    case SET_PENDING_SEASON: {
      return {
        ...state,
        pendingSeason: action.payload
      };
    }
    case SET_TEAM_MYTHIC_PLUS_RUNS: {
      return {
        ...state,

        events: {
          ...state.events,
          [action.payload.eventId || 0]: {
            ...(state.events ? state.events[action.payload.eventId || 0] : {}),
            ...action.payload.details
          }
        },

        openDungeons: {}
      };
    }
    case SET_TEAM_MYTHIC_PLUS_FILTERS: {
      return {
        ...state,
        filters: {
          ...(state.filters || {
            mode: 'scored'
          }),
          ...action.payload
        },
        openDungeons: {}
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        events: {
          ...state.events,
          [action.payload.eventId || 0]: {
            ...(state.events ? state.events[action.payload.eventId || 0] : {}),
            isLoading: action.payload.show
          }
        }
      };
    }
    case TOGGLE_OPEN_DUNGEON: {
      return {
        ...state,
        openDungeons: {
          ...(state.openDungeons || {}),
          [action.payload]: state.openDungeons ? !state.openDungeons[action.payload] : true
        }
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
